const rawUrl = (import.meta.env.VITE_API_URL as string) || 'http://localhost:5000';

export const SERVER_URL = rawUrl.replace(/\/+$/, '').replace(/\/api$/, '');
export const API_URL = `${SERVER_URL}/api`;